function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".warning-ic_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#fca467}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "warning-ic_svg__UI-_x2F_-Info-deposit-Copy-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "warning-ic_svg__Group",
  transform: "translate(12 8)"
}, /*#__PURE__*/React.createElement("path", {
  id: "warning-ic_svg___x21_",
  className: "warning-ic_svg__st0",
  d: "M.8 5H-.8V0H.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "warning-ic_svg___x21_-copy",
  className: "warning-ic_svg__st0",
  d: "M.8 8H-.8V6.7H.8z"
})), /*#__PURE__*/React.createElement("path", {
  id: "warning-ic_svg__Triangle",
  d: "M13.3 3.2l7.6 13c.4.7.2 1.6-.5 2.1-.2.1-.5.2-.8.2H4.4c-.8 0-1.5-.7-1.5-1.5 0-.3.1-.5.2-.8l7.6-13c.4-.7 1.3-1 2.1-.5.2.1.4.3.5.5z",
  fill: "none",
  stroke: "#fca467",
  strokeWidth: 1.5
}));

function SvgWarningIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning-ic_svg__Layer_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "fc69b8dfb9ee791bec1345e0dd510131.svg";
export { SvgWarningIc as ReactComponent };